import { defineStore } from 'pinia';
import { ref } from 'vue';

export interface Toast {
  readonly id: string;
  readonly message: string;
  readonly kind: 'info' | 'success' | 'warning' | 'error';
}

export const useUiStore = defineStore('ui', () => {
  const toasts = ref<Toast[]>([]);

  function pushToast(t: Omit<Toast, 'id'> & { autoDismissMs?: number }): string {
    const id = crypto.randomUUID();
    toasts.value.push({ id, message: t.message, kind: t.kind });
    const ms = t.autoDismissMs ?? (t.kind === 'error' ? 0 : 4000);
    if (ms > 0) setTimeout(() => dismissToast(id), ms);
    return id;
  }

  function dismissToast(id: string) {
    toasts.value = toasts.value.filter((t) => t.id !== id);
  }

  return { toasts, pushToast, dismissToast };
});
